var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBingoStar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 609,
    height: 818,
    viewBox: "0 0 609 818",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.158 17.3458L350.085 264.797C351.265 271.385 355.675 277.088 361.906 280.115L596.097 390.794C611.777 398.257 612.407 419.682 596.984 427.173L368.001 537.84C361.872 540.795 357.693 546.522 356.886 553.166L325.543 800.559C323.441 817.21 302.531 823.8 290.094 811.805L105.644 632.818C100.669 628.02 93.7457 625.859 86.9252 626.976L-166.589 669.276C-183.64 672.067 -197.09 654.754 -189.347 639.863L-74.4116 418.559C-71.2966 412.635 -71.4765 405.548 -74.8359 399.632L-200.186 178.243C-208.61 163.31 -196.034 146.006 -178.764 148.827L76.8064 191.001C83.6143 192.179 90.4861 189.997 95.2423 185.126L271.131 6.10193C283.027 -5.86982 304.31 0.772486 307.158 17.3458Z",
    fill: "#C0FF88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBingoStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bingo_Star.930171b7319135e0499d13d851f17ca2.svg";